<!--
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: smallWhite
 * @Date: 2023-05-12 20:36:16
 * @LastEditors: smallWhite
 * @LastEditTime: 2023-05-30 14:38:35
 * @FilePath: /siana_admin/src/views/system/baidu/index.vue
-->
<template>
  <el-card>
    <div slot="header">
      <h2>百度配置
      </h2>
    </div>
    <el-form ref="ruleForm"
      :model="form"
      :rules="rules"
      label-width="180px"
      :label-position="phone?'top':'right'"
      class="demo-ruleForm">

      <el-form-item
        label="百度应用key"
        prop="baiduKey">
        <el-input
          v-model="form.baiduKey"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        label="百度应用Secret"
        prop="baiduSecretKey">
        <el-input
          v-model="form.baiduSecretKey"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        label="百度Secret"
        prop="baiduSecret">
        <el-input
          v-model="form.baiduSecret"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        v-if="!disabled">
        <el-button
          type="primary"
          @click="handleSubmit()">保存</el-button>
        <el-button
          @click="handleCancel()">取消</el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button
          type="primary"
          @click="disabled = !disabled">去编辑</el-button>

      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      phone: false,
      form: {
        baiduKey: '', // gpt请求地址
        baiduSecretKey: '', // 默认注册次数
        baiduSecret: ''
      },
      disabled: true,
      rules: {
        baiduSecret: [{ required: false, message: '请输入', trigger: 'blur' }],
        baiduKey: [{ required: false, message: '请输入', trigger: 'blur' }],
        baiduSecretKey: [{ required: false, message: '请输入', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.phone = JSON.parse(window.localStorage.getItem('phone'))
    this.getData()
  },
  methods: {
    getData() {
      this.$https('SYSTEMSETTING', {}).then(res => {
        this.form = {
          id: res.data.id,
          baiduSecret: res.data.baiduSecret, // 注册模式  1 账号密码 2 邮箱注册 3 公众号
          baiduKey: res.data.baiduKey, // gpt请求地址
          baiduSecretKey: res.data.baiduSecretKey // stablediffusion lora地址
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$https('SYSTEMEDIT', this.form).then(res => {
            if (res.status == 200) {
              this.$message.success('编辑成功！')
              this.disabled = true
            }
          })
        }
      })
    },
    handleCancel() {
      this.form = {
        id: '',
        baiduSecret: '', // 注册模式  1 账号密码 2 邮箱注册 3 公众号
        baiduKey: '', // gpt请求地址
        baiduSecretKey: ''
      }
      this.getData()
      this.disabled = true
    }
  }
}
</script>

<style>
</style>
